/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnDesktopPlatform } from './en-desktop-platform';
import { EnStationType } from './en-station-type';
import { JoinEntityDto } from './join-entity-dto';
import { StationComponentDto } from './station-component-dto';
 /**
 *
 *
 * @export
 * @interface StationDto
 */
export interface StationDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof StationDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof StationDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof StationDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof StationDto
     */
    deleted: string | null;

    /**
     * Human-readable name for the kiosk (e.g. \"Kiosk Floor 2 - Room 4\")
     *
     * @type {string}
     * @memberof StationDto
     */
    name: string;

    /**
     * Hardware identifier (e.g. motherboard serial, BIOS UUID)
     *
     * @type {string}
     * @memberof StationDto
     */
    deviceId: string;

    /**
     * @type {EnDesktopPlatform}
     * @memberof StationDto
     */
    platform: EnDesktopPlatform;

    /**
     * OS version (e.g. \"Windows 11 23H2\", \"Ubuntu 24.04\", \"macOS 14.4\")
     *
     * @type {string}
     * @memberof StationDto
     */
    systemVersion: string;

    /**
     * Unity app version (e.g. \"1.0.0\")
     *
     * @type {string}
     * @memberof StationDto
     */
    appVersion: string;

    /**
     * @type {string}
     * @memberof StationDto
     */
    ksn: string;

    /**
     * @type {EnStationType}
     * @memberof StationDto
     */
    type: EnStationType;

    /**
     * @type {string}
     * @memberof StationDto
     */
    note?: string;

    /**
     * @type {Array<StationComponentDto>}
     * @memberof StationDto
     */
    components: Array<StationComponentDto>;

    /**
     * @type {JoinEntityDto}
     * @memberof StationDto
     */
    client: JoinEntityDto;

    /**
     * @type {number}
     * @memberof StationDto
     */
    placeId: number;
}
